import React from 'react';
import { Card, Table, Spin, Tag } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import './EvolutionTable.scss';

const EvolutionTable = ({ data = [], loading = false, showSubBadge = false }) => {
  const formatCurrency = (value) => {
    return (value / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
  };

  const formatPercentage = (value) => {
    return `${value.toFixed(2)}%`;
  };

  const getPercentageColor = (value) => {
    return value >= 0 ? '#52c41a' : '#ff4d4f';
  };

  const getPercentageIcon = (value) => {
    return value >= 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
  };

  const columns = [
    {
      title: 'Conta',
      key: 'account_name',
      ellipsis: true,
      width: '40%',
      render: (_, record) => (
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          {showSubBadge && record.account?.type?.toLowerCase().includes('sub') && (
            <Tag color="orange" style={{ margin: 0 }}>SUB</Tag>
          )}
          {record.account?.display_name}
        </span>
      ),
    },
    {
      title: 'Período Atual',
      dataIndex: 'current_period_total',
      key: 'current_period',
      render: (value) => formatCurrency(value),
      align: 'right',
      width: '20%',
      sorter: (a, b) => a.current_period_total - b.current_period_total,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Período Anterior',
      dataIndex: 'previous_period_total',
      key: 'previous_period',
      render: (value) => formatCurrency(value),
      align: 'right',
      width: '20%',
      sorter: (a, b) => a.previous_period_total - b.previous_period_total,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Variação',
      dataIndex: 'change_percentage',
      key: 'change_percentage',
      render: (value) => (
        <span style={{ color: getPercentageColor(value) }}>
          {getPercentageIcon(value)} {formatPercentage(value)}
        </span>
      ),
      align: 'right',
      width: '20%',
      sorter: (a, b) => a.change_percentage - b.change_percentage,
      sortDirections: ['descend', 'ascend'],
    },
  ];

  const tableData = data.map((item, index) => ({
    ...item,
    key: item.account?.id || index,
  }));

  return (
    <Card 
      title="Evolução"
      className="evolution-table-card"
      size="small"
    >
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={tableData}
          size="small"
          pagination={{
            size: 'small',
            showSizeChanger: false,
            showQuickJumper: false,
            pageSize: 10,
          }}
          scroll={{ x: 'max-content' }}
        />
      </Spin>
    </Card>
  );
};

export default EvolutionTable;